/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { FileProcessStatus } from './FileProcessStatus';
import {
    FileProcessStatusFromJSON,
    FileProcessStatusFromJSONTyped,
    FileProcessStatusToJSON,
    FileProcessStatusToJSONTyped,
} from './FileProcessStatus';

/**
 * 
 * @export
 * @interface FileProcessResultResponse
 */
export interface FileProcessResultResponse {
    /**
     * 
     * @type {FileProcessStatus}
     * @memberof FileProcessResultResponse
     */
    status?: FileProcessStatus;
    /**
     * 
     * @type {string}
     * @memberof FileProcessResultResponse
     */
    readonly message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileProcessResultResponse
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {number}
     * @memberof FileProcessResultResponse
     */
    rowsInvalid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileProcessResultResponse
     */
    errorReportUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileProcessResultResponse
     */
    rowsValid?: number | null;
}



/**
 * Check if a given object implements the FileProcessResultResponse interface.
 */
export function instanceOfFileProcessResultResponse(value: object): value is FileProcessResultResponse {
    return true;
}

export function FileProcessResultResponseFromJSON(json: any): FileProcessResultResponse {
    return FileProcessResultResponseFromJSONTyped(json, false);
}

export function FileProcessResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileProcessResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : FileProcessStatusFromJSON(json['status']),
        'message': json['message'] == null ? undefined : json['message'],
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'rowsInvalid': json['rowsInvalid'] == null ? undefined : json['rowsInvalid'],
        'errorReportUrl': json['errorReportUrl'] == null ? undefined : json['errorReportUrl'],
        'rowsValid': json['rowsValid'] == null ? undefined : json['rowsValid'],
    };
}

export function FileProcessResultResponseToJSON(json: any): FileProcessResultResponse {
    return FileProcessResultResponseToJSONTyped(json, false);
}

export function FileProcessResultResponseToJSONTyped(value?: Omit<FileProcessResultResponse, 'message'|'httpStatusCode'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': FileProcessStatusToJSON(value['status']),
        'rowsInvalid': value['rowsInvalid'],
        'errorReportUrl': value['errorReportUrl'],
        'rowsValid': value['rowsValid'],
    };
}

